"use strict";

exports.__esModule = true;
var _DeviceLagContext = require("./DeviceLagContext");
Object.keys(_DeviceLagContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceLagContext[key]) return;
  exports[key] = _DeviceLagContext[key];
});